import * as React from 'react';
import * as styles from './AddressEditingWarning.css';

export const AddressEditingWarning: React.FC = props => {
  const { children } = props;

  return <div className={styles['wrapper']}>{children}</div>;
};
